import {Node} from "../Node";
import {AbstractProperty} from "./AbstractProperty";
import {assertNotNull, MetadataRow} from "../../global";

export class PForeignKey extends AbstractProperty<string, Node> {

    default: string;
    selectOptions: string[];
    foreignKey: string;

    constructor(args) {
        super({
            type: 'ForeignKey',
            default: null,
            ...args,
        });
        assertNotNull('selectOptions', this.selectOptions);
        assertNotNull('foreignKey', this.foreignKey);
    }

    typeCheck(value) {
        return true;
    }

    toThree(instance) {
    }

    fromThree(instance) {
    }

    threeToInternalFormat(value) {
        throw new Error('not intended');
    }

    fromMetadataRow(row) {
        const value = row[this.name];
        this.set(value?.Key);
        return this;
    }

    toMetadataRow(metadataRow: MetadataRow): this {
        metadataRow[this.name] = this.get();
        return this;
    }

}
